import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export function formatUserIdentity(user) {
    return {
        "fname": user.firstName,
        "lname": user.lastName,
        "email": user.email,
        "phone": user.phoneNo,
        "dateOfBirth": dayjs(user.dob).format("YYYY-MM-DD"),
        "amount": user.returning ? 7900 : 11900,
        "patientID": user.patientID,
    };
}
